module.exports = __webpack_public_path__ + "img/logo-text-only-black.70b376ec.svg";